import React from 'react'
import TextFieldM, { TextFieldProps } from '@mui/material/TextField'
import FormLabel from './FormLabel'

type LocalProps = {
  input?: Record<string, any>
  meta?: Record<string, string>
  disableRadius?: boolean
  requiredtab?: boolean[]
  hideLabel?: boolean
  testId?: string
}

const TextField: React.ComponentType<LocalProps & TextFieldProps> = ({
  input: { name, onChange, value, ...restInput } = {},
  meta = {},
  disableRadius = false,
  testId = 'inputTester',
  label,
  placeholder,
  required,
  requiredtab,
  hideLabel = false,
  ...rest
}) => {
  const showError = !!(
    ((meta.submitError && !meta.dirtySinceLastSubmit) || meta.error) &&
    meta.touched
  )
  return (
    <>
      {label && !hideLabel && (
        <FormLabel required={!!requiredtab?.[name] || !!required}>{label}</FormLabel>
      )}
      <TextFieldM
        {...rest}
        margin="dense"
        sx={
          disableRadius
            ? {
                '& .MuiOutlinedInput-root, & fieldset, & input': {
                  borderRadius: 0,
                },
              }
            : undefined
        }
        variant="outlined"
        name={name}
        onChange={onChange}
        value={value}
        data-testid={testId}
        error={showError}
        placeholder={(!!label && String(label)) || placeholder}
        inputProps={{
          autoComplete: 'new-password',
          form: {
            autocomplete: 'off',
          },
          ...restInput,
        }}
        helperText={showError ? `${label} ${meta.error || meta.submitError}` : undefined}
      />
    </>
  )
}

export default TextField
